import React, { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogTitle, DialogActions } from "@material-ui/core";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import TextField from "@material-ui/core/TextField";
import { Button } from "primereact/button";
import cogoToast from "cogo-toast";
import { CommonConfig } from "../../../CommonConfig.js";
import APIConstant from "utils/constant.js";
import api from "utils/api.js";

const AddCompanyMaster = ({ open, onClose, company, userId, refresh }) => {
    const [companyName, setCompanyName] = useState("");
    const [companyNameErr, setCompanyNameErr] = useState(false);
    const [companyNameErrText, setCompanyNameErrText] = useState("");

    const [gstNo, setGstNo] = useState("");
    const [gstNoErr, setGstNoErr] = useState(false);
    const [gstNoErrText, setGstNoErrText] = useState("");

    const [panNo, setPanNo] = useState("");
    const [panNoErr, setPanNoErr] = useState(false);
    const [panNoErrText, setPanNoErrText] = useState("");

    const [address, setAddress] = useState("");
    const [addressErr, setAddressErr] = useState(false);
    const [addressErrText, setAddressErrText] = useState("");

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (company) {
            setCompanyName(company?.CompanyName);
            setGstNo(company?.GSTNo);
            setPanNo(company?.PanNo);
            setAddress(company?.address?.Address);
        } else {
            setCompanyName("");
        }
    }, [company]);

    const validate = () => {
        if (CommonConfig.isEmpty(companyName)) {
            setCompanyNameErr(true);
            setCompanyNameErrText("Company is required.");
            return false;
        }
        setCompanyNameErr(false);
        setCompanyNameErrText("");
        return true;
    };

    const handleSubmit = async () => {
        if (!validate()) return;

        setLoading(true);
        try {
            const params = {
                CompanyName: companyName,
                GSTNo: gstNo,
                PANNo: panNo,
                Address: address,
                CompanyMasterId: company?._id || "",
                UserId: userId,
            };
            const res = await api.post(APIConstant.path.AddUpdateCompanyMaster, params);
            if (res.success) {
                cogoToast.success(res.message);
                refresh();
                onClose();
            } else {
                cogoToast.error(res.message);
            }
        } catch {
            cogoToast.error("Failed to save company");
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e, type) => {
        if (type == 'companyName') {
            if (CommonConfig.isEmpty(e.target.value)) {
                setCompanyName(e.target.value);
                setCompanyNameErr(true);
                setCompanyNameErrText('Company name is required')
            } else {
                setCompanyName(e.target.value);
                setCompanyNameErr(false);
                setCompanyNameErrText('')
            }
        }
        else if (type == 'gstNo') {
            if (CommonConfig.isEmpty(e.target.value)) {
                setGstNo(e.target.value);
                setGstNoErr(true);
                setGstNoErrText('Gst No is required')
            } else {
                setGstNo(e.target.value.toUpperCase());
                setGstNoErr(false);
                setGstNoErrText('')
            }
        }
        if (type == 'panNo') {
            if (CommonConfig.isEmpty(e.target.value)) {
                setPanNo(e.target.value);
                setPanNoErr(true);
                setPanNoErrText('Pan no is required')
            } else {
                setPanNo(e.target.value.toUpperCase());
                setPanNoErr(false);
                setPanNoErrText('')
            }
        }
        if (type == 'address') {
            if (CommonConfig.isEmpty(e.target.value)) {
                setAddress(e.target.value);
                setAddressErr(true);
                setAddressErrText('Address is required')
            } else {
                setAddress(e.target.value);
                setAddressErr(false);
                setAddressErrText('')
            }
        }
    }

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>{company ? "Edit Company" : "Add Company"}</DialogTitle>
            <DialogContent>
                <GridContainer>
                    <GridItem md={12}>
                        <TextField
                            autoFocus
                            margin="dense"
                            label="Company Name*"
                            type="text"
                            value={companyName}
                            onChange={(e) => handleChange(e, 'companyName')}
                            error={companyNameErr}
                            helperText={companyNameErrText}
                            fullWidth
                        />
                    </GridItem>
                    <GridItem md={12}>
                        <TextField
                            autoFocus
                            margin="dense"
                            label="Gst No"
                            type="text"
                            value={gstNo}
                            onChange={(e) => handleChange(e, 'gstNo')}
                            error={gstNoErr}
                            helperText={gstNoErrText}
                            fullWidth
                        />
                    </GridItem>
                    <GridItem md={12}>
                        <TextField
                            autoFocus
                            margin="dense"
                            label="Pan no"
                            type="text"
                            value={panNo}
                            onChange={(e) => handleChange(e, 'panNo')}
                            error={panNoErr}
                            helperText={panNoErrText}
                            fullWidth
                        />
                    </GridItem>
                    <GridItem md={12}>
                        <TextField
                            autoFocus
                            margin="dense"
                            label="Address"
                            type="text"
                            value={address}
                            onChange={(e) => handleChange(e, 'address')}
                            error={addressErr}
                            helperText={addressErrText}
                            fullWidth
                        />
                    </GridItem>
                </GridContainer>
            </DialogContent>
            <DialogActions>
                <Button label="Close" className="p-button-text" onClick={onClose} />
                <Button label="Submit" onClick={handleSubmit} disabled={loading} />
            </DialogActions>
        </Dialog>
    );
};

export default AddCompanyMaster;
